import { createContext, useContext } from 'react';

import { useMergedAppSettings } from './slices/settings/hooks';
import { type Settings } from './slices/settings/types';

const AppSettingsContext = createContext<Settings | null>(null);

export const AppSettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const settings = useMergedAppSettings();
  return <AppSettingsContext.Provider value={settings}>{children}</AppSettingsContext.Provider>;
};

export const useAppSettingsContext = () => {
  const context = useContext(AppSettingsContext);

  if (context === null) {
    throw new Error('useAppSettingsContext must be used within an AppSettingsProvider');
  }

  return context;
};
